import { ShieldMoonOutlineIcon } from './ShieldMoonOutlineIcon';

/**
 * author: Michael Irigoyen
 * id C70DD8EF-9F17-41E0-825C-C5AAC60DBF1E
 * name shield-moon-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-moon-outline.svg
 * tags
 * - Home Automation 
 */
export const AlarmArmNightOutlineIcon = ShieldMoonOutlineIcon;
export default AlarmArmNightOutlineIcon